import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    auditUsersLoading: false,
    auditUsers: {},
    auditUserError: "",
    auditUserDetailsLoading: false,
    auditUserDetailsUser: {},
    auditRoles: [],
    audiUserDetailsError: "",
    allCategoiresByGoalId: [],
    allSubCategoiresByCategoryId: [],
    detailsUser: {}


}

export const auditUserSlice = createSlice({
    name: 'auditUser',
    initialState,
    reducers: {
        getAuditUserListLoading: (state, action) => {
            state.auditUsersLoading = true
        },
        getAuditUserListSuccess: (state, action) => {
            state.auditUsersLoading = false;
            state.auditUsers = action.payload
        },
        getAuditUsersListError: (state, action) => {
            state.auditUsersLoading = false;
            state.auditUsers = []
            state.auditUserError = action.payload.message
        },
        getAuditUserDetailsLoading: (state, action) => {
            state.auditUserDetailsLoading = true
        },
        getAuditUserDetailsSuccess: (state, action) => {
            state.auditUserDetailsLoading = false;
            state.auditUserDetailsUser = action.payload.data;
            state.audiUserDetailsError = null;

        },
        getAuditUserDetailsError: (state, action) => {
            state.audiUserDetailsError = action.payload.message
        },
        setAllCategoriesByGoalId: (state, action) => {
            state.allCategoiresByGoalId = action.payload.data.map((item) => ({ ...item, value: item.id, label: item.name }));
        },
        setAllSubCategoiresByCategoryId: (state, action) => {
            state.allSubCategoiresByCategoryId = action.payload.data?.map((item) => ({ ...item, value: item.id, label: item.name })) || [];
        },
        resetDetails: (state, action) => {
            state.auditUserDetailsUser = {};
            state.auditRoles = []
            state.detailsUser = {}
        },
        resetSubCategoires: (state, action) => {
            state.allSubCategoiresByCategoryId = []
        },
        resetCategories: (state, action) => {
            state.allCategoiresByGoalId = []
        },
        setUserDetails: (state, action) => {
            state.auditUserDetailsLoading = false;
            state.detailsUser = action.payload.data
        }
    },
})

// Action creators are generated for each case reducer function
export const {
    getAuditUserListLoading,
    getAuditUserListSuccess,
    getAuditUsersListError,
    getAuditUserDetailsLoading,
    getAuditUserDetailsSuccess,
    getAuditUserDetailsError,
    setAllCategoriesByGoalId,
    setAllSubCategoiresByCategoryId,
    resetDetails,
    resetSubCategoires,
    resetCategories,
    setUserDetails
} = auditUserSlice.actions

export default auditUserSlice.reducer;